// Generated by purs version 0.15.0
import * as $foreign from "./foreign.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Control_Monad_Cleanup from "../Control.Monad.Cleanup/index.js";
import * as Control_Monad_Replace from "../Control.Monad.Replace/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Tuple from "../Data.Tuple/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Specular_Dom_Builder from "../Specular.Dom.Builder/index.js";
import * as Specular_Dom_Builder_Class from "../Specular.Dom.Builder.Class/index.js";
var runWidgetInNode = function (parent) {
    return function (widget) {
        return Specular_Dom_Builder.runBuilder(parent)(Control_Bind.bind(Specular_Dom_Builder.bindBuilder)(Control_Monad_Replace.newSlot(Specular_Dom_Builder.monadReplaceBuilder))(function (slot) {
            return Control_Bind.discard(Control_Bind.discardUnit)(Specular_Dom_Builder.bindBuilder)(Control_Monad_Cleanup.onCleanup(Specular_Dom_Builder.monadCleanupBuilder)(Control_Monad_Replace.destroySlot(slot)))(function () {
                return Effect_Class.liftEffect(Specular_Dom_Builder.monadEffectBuilder)(Control_Monad_Replace.replaceSlot(slot)(widget));
            });
        }));
    };
};
var spawnWidgetInNode = function (dictMonadEffect) {
    return function (dictMonadCleanup) {
        return function (node) {
            return function (widget) {
                return Control_Bind.bind((dictMonadCleanup.Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadEffect)(runWidgetInNode(node)(widget)))(function (v) {
                    return Control_Bind.discard(Control_Bind.discardUnit)((dictMonadCleanup.Monad0()).Bind1())(Control_Monad_Cleanup.onCleanup(dictMonadCleanup)(v.value1))(function () {
                        return Control_Applicative.pure((dictMonadCleanup.Monad0()).Applicative0())(v.value0);
                    });
                });
            };
        };
    };
};
var spawnWidgetInBody = function (dictMonadEffect) {
    return function (dictMonadCleanup) {
        return function (widget) {
            return Control_Bind.bind((dictMonadCleanup.Monad0()).Bind1())(Effect_Class.liftEffect(dictMonadEffect)($foreign.documentBody))(function (body) {
                return spawnWidgetInNode(dictMonadEffect)(dictMonadCleanup)(body)(widget);
            });
        };
    };
};
var runWidgetInBody = function (widget) {
    return function __do() {
        var body = $foreign.documentBody();
        return runWidgetInNode(body)(widget)();
    };
};
var runMainWidgetInNode = function (parent) {
    return function (widget) {
        return Data_Functor.map(Effect.functorEffect)(Data_Tuple.fst)(runWidgetInNode(parent)(widget));
    };
};
var runMainWidgetInBody = function (widget) {
    return function __do() {
        var body = $foreign.documentBody();
        return runMainWidgetInNode(body)(widget)();
    };
};
var monadWidget = function (dictMonadDomBuilder) {
    return function (dictMonadFRP) {
        return function (dictMonadReplace) {
            return function (dictMonoid) {
                return {
                    MonadDomBuilder0: function () {
                        return dictMonadDomBuilder;
                    },
                    MonadFRP1: function () {
                        return dictMonadFRP;
                    },
                    MonadReplace2: function () {
                        return dictMonadReplace;
                    },
                    Monoid3: function () {
                        return dictMonoid;
                    }
                };
            };
        };
    };
};
var liftWidget = function (dictMonadDomBuilder) {
    return function (w) {
        var v = Specular_Dom_Builder.unBuilder(w);
        return Specular_Dom_Builder_Class.liftBuilder(dictMonadDomBuilder)(function (env) {
            return v({
                parent: env.parent,
                cleanup: env.cleanup,
                userEnv: Data_Unit.unit
            });
        });
    };
};
var emptyWidget = /* #__PURE__ */ Control_Applicative.pure(Specular_Dom_Builder.applicativeBuilder)(Data_Unit.unit);
export {
    runWidgetInNode,
    runWidgetInBody,
    runMainWidgetInNode,
    runMainWidgetInBody,
    spawnWidgetInNode,
    spawnWidgetInBody,
    liftWidget,
    emptyWidget,
    monadWidget
};
//# sourceMappingURL=index.js.map
